import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'countinue-update',
    components: {
    },
})

export default class CountinueUpdate extends Vue {

    private onBackTolist(key: any) {
        this.$emit('onChangeComponent', key);
    }

    private goToParent(key: any) {
        this.$emit('onBackParent', key );
    }

}
